<template>
  <div class="header">
    <div class="page-inner">
      <i
        class="icon icon-logo_xiangyun"
        is="router-link"
        :to="{ name: 'index' }"
      ></i>
      <ul class="link-group">
        <li class="link" is="router-link" :to="{ name: 'index' }">首页</li>
        <li class="link" is="router-link" :to="{ name: 'activitycenter' }">
          活动中心
        </li>
        <li class="link" is="router-link" :to="{ name: 'productcenter' }">
          产品中心
        </li>
        <li class="link" is="router-link" :to="{ name: 'recruitment' }">
          招贤纳士
        </li>
        <li class="link" is="router-link" :to="{ name: 'aboutus' }">
          关于我们
        </li>
        <li class="link" is="router-link" :to="{ name: 'personal' }">
          个人中心
        </li>
      </ul>
      <i class="icon"></i>
      <div class="user">
        <el-button
          class="btn"
          v-if="!loginedUser"
          @click="loginModalVisible = true"
          >登录</el-button
        >
        <el-button
          class="btn logined"
          v-if="loginedUser"
          style="max-width: 90px;vertical-align: middle;"
          >{{ loginedUser.nickname }} <i class="el-icon-caret-bottom"></i
        ></el-button>
        <div class="logined-popover" v-show="loginedUser">
          <ul>
            <li @click="showUserInfo">个人信息</li>
            <li @click="logout">退出登录</li>
          </ul>

          <div class="arrow">
            <em></em>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <modal :open.sync="loginModalVisible"></modal>
    <modal
      :open.sync="userModalVisible"
      mode="userInfo"
      :userInfo="loginedUser"
    ></modal>

    <!-- 个人信息 -->
    <!-- <el-dialog title="个人信息" :visible.sync="dialogFormVisible">




    </el-dialog> -->
    <!-- 个人信息 -->
  </div>
</template>

<script type="text/ecmascript-6">
import Modal from '@/components/modal';
import eventBus from '@/utils/eventBus';
import cookie from '@/utils/cookie';


export default {
  name: 'headers',
  data() {
    return {
      loginModalVisible: false,
      loginedUser: null,
      userModalVisible: false
    }
  },
  // props: {
  //   initShowModal: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  methods: {
    logout() {
      this.$confirm('即将登出当前用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear();
        this.loginedUser = null;
        this.$message({
          type: 'success',
          message: '登出成功!'
        });
        this.loginedUser = null;
        // if (['deliver', 'order', 'bill'].some(url => this.$route.name === url)) {
        //   this.$router.push({
        //     name: 'inquiry'
        //   });
        // }
        this.$router.push('/index')
      }).catch(() => null);
    },
    showUserInfo() {
      this.userModalVisible = true;
    }
  },
  components: {
    Modal
  },
  created() {

    eventBus.on('login', (data) => {
      this.loginedUser = data;
    });

    eventBus.on('showLogin', () => {
      this.loginModalVisible = true;
    });

    const loginedUser = sessionStorage.getItem('user');
    if (loginedUser) {
      this.loginedUser = JSON.parse(cookie.getCookie(loginedUser));
    }

  },
  mounted() {
    if (this.$route.query.showLogin) {
      this.loginModalVisible = true;
    }
  },
  watch: {
    '$route' () {
      this.$utils.watchRouteGoAnchor(this);
      // if (this.$route.query.showLogin) {
      //   this.loginModalVisible = true;
      // }
      // if(['deliver', 'order', 'bill'].some(url => this.$route.name === url) && !this.loginedUser) {
      //   this.$router.push({ name: 'inquiry' });
      //   this.loginModalVisible = true;
      // }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../style/common/base";
@import "../style/_variable";

.header {
  position: fixed;
  top: 0;
  padding-top: 10px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  z-index: 99;
  .el-button--default.logined {
    max-width: 120px !important;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .logined-popover {
    display: none;
    position: absolute;
    left: 50%;
    top: 50px;
    width: 110px;
    height: 100px;
    border: 1px solid $border-clr;
    margin-left: -55px;
    background: #fff;
    border-radius: 4px;
    z-index: 1;

    li {
      width: 90px;
      height: 35px;
      line-height: 35px;
      margin: 10px;
      text-align: center;
      color: $text-clr_light;
      font-size: 14px;
      cursor: pointer;
      user-select: none;

      &:hover {
        background: $text-clr_primary;
        border-radius: 18px;
        color: #fff;
      }
    }
  }

  .icon {
    &-logo_xiangyun:before {
      width: 129px;
      height: 48px;
      background: url("~@/assets/images/logo/logo_xiangyun.png") center
        no-repeat;
      background-size: 129px;
      vertical-align: middle;
    }
  }
  .link {
    display: inline-block;
    margin-right: 40px;
    font-size: 16px;
    &:first-child {
      margin-right: 70px;
    }
    &:last-child {
      margin-right: 100px;
    } // 非激活状态
    &:after {
      content: "";
      display: block;
      background-color: white;
      width: 0px;
      height: 4px;
      border-radius: 2px;
      margin: 10px auto;
      transition: all 0.2s;
    } // 集合状态
    &.router-link-active {
      color: $text-clr_primary;
      &:after {
        content: "";
        display: block;
        background-color: #00a7f7;
        width: 18px;
        height: 4px;
        border-radius: 2px;
        margin: 10px auto;
      }
    }

    &:hover {
      &:after {
        content: "";
        display: block;
        background-color: #00a7f7;
        width: 18px;
        height: 4px;
        border-radius: 2px;
        margin: 10px auto;
      }
    }

    &-group {
      display: inline-block; // vertical-align: middle;
      margin-left: 162px;
    }

    .btn:hover {
      color: $text-clr_primary;
    }
  }
  .btn:hover {
    color: $text-clr_primary;
  }
  .user {
    display: inline;
    position: relative;
    padding: 15px 0;
    margin-left: -40px;
  }
  .user:hover,
  .user:focus,
  .user:active {
    .logined-popover {
      display: block;
    }
  }
  .arrow {
    position: absolute;
    top: -20px;
    left: 40px;
    width: 10px;
    height: 10px;
  }

  .arrow * {
    display: block;
    border-width: 10px;
    position: absolute;
    border-style: dashed dashed dashed solid;
    font-size: 0;
    line-height: 0;
  }

  .arrow em {
    border-color: transparent transparent $border-clr;
  }

  .arrow span {
    border-color: transparent transparent #fff;
    top: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue